<div class="SLV2-formulacrdBanner-box">
    <h3 class="SLV2-formulacrdBanner-title">
        <img class="icon-img" src="selflearnv2-ui/assets/img/self-learn-v2/formula-card-icon.svg" />
        <span>Formula sheets</span>
    </h3>

    <p class="SLV2-formulacrdBanner-text">Check out all the formula’s that you’ve bookmarked till now!</p>

    <button class="SLV2-prctcs-solid-button">Go to Formula sheets</button>
</div>